import ActionCreator from "../../utils/redux/ActionCreator";
import { getTemplates, getTemplate, addOrUpdate, deleteTemplate } from "core/database/template";

const { actions, defaultReducer, get, getSimple, add, remove, update } = new ActionCreator("template");
export { actions, defaultReducer };


export const getTemplateByIdData = getSimple(getTemplate);
export const getTemplateData = get(getTemplates);
export const addTemplateData = add(addOrUpdate);
export const updateTemplateData = update(addOrUpdate);
export const deleteTemplateData = remove(deleteTemplate);